<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <form class="build-scan-report-container" [formGroup]="groupEdwForm">
    <ion-row class="custom-row">
      <ion-col>
        <div class="form-group form-group-lg no-margin">
          <label class="date-label">{{ CONSTS.DATE_LABEL }} </label>
        </div>
        <app-form-date-picker
          formControlName="date"
          class="report-date-picker"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [icon]="IMAGES.CALENDAR"
        ></app-form-date-picker>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-report-format
          [radioButtonValue]="groupEdwForm.get('reportFormat')?.value"
          (emitRadioChange)="radioChange($event)"
        ></app-report-format>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>
<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    groupEdwSummaryReport && groupEdwSummaryReport.response.groupEDWSummary
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasTotalRow]="true"
  [hasSingleSubHeaderView]="false"
>
  @if (groupEdwSummaryReport && groupEdwSummaryReport.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.GROUP }}
            {{ groupEdwSummaryReport.response.group }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.GROUP_NAME }}
            {{ groupEdwSummaryReport.response.groupName }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.DATE }}
            {{ groupEdwSummaryReport.response.date }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
  <ng-container total-row>
    @if (groupEdwSummaryReport && groupEdwSummaryReport.response) {
      <table
        aria-hidden="true"
        class="pdf-total-table"
      >
        <tr class="pdf-total-row">
          <td class="pdf-total-cell">{{ PDF_REPORT.FOOTER.TOTAL }}</td>
          <td class="pdf-total-cell"></td>
          <td class="pdf-total-cell">
            {{ groupEdwSummaryReport.response.totalTotalStops }}
          </td>
          <td class="pdf-total-cell">
            {{ groupEdwSummaryReport.response.totalTotalPkgs }}
          </td>
          <td class="pdf-total-cell">
            {{ groupEdwSummaryReport.response.totalNumOfTotalStopswithEDW }}
          </td>
          <td class="pdf-total-cell">
            {{ groupEdwSummaryReport.response.totalNumOfTotalStopsEDWMet }}
          </td>
          <td class="pdf-total-cell">
            {{ groupEdwSummaryReport.response.totalPercentOfTotalStopsEDWMet }}
          </td>
          <td class="pdf-total-cell">
            {{ groupEdwSummaryReport.response.totalNumOfCommittedStopswithEDW }}
          </td>
          <td class="pdf-total-cell">
            {{ groupEdwSummaryReport.response.totalNumOfCommittedStopsEDWMet }}
          </td>
          <td class="pdf-total-cell">
            {{
              groupEdwSummaryReport.response.totalPercentOfCommittedStopsEDWMet
            }}
          </td>
        </tr>
      </table>
    }
  </ng-container>
</app-pdf-report-generator>
